import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--dim-grey);
  font-size: 14px;
  line-height: 20px;
`;

export const IconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--dim-grey);
`;

export const Separator = styled.span`
  color: var(--dim-grey);
`;

export const FileName = styled.span`
  color: var(--dim-grey);
  word-break: break-all;
`;
